import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Box, Typography, Button, IconButton, Card, CardMedia, CardContent} from '@mui/material';
import { Delete, Favorite, FavoriteBorder } from '@mui/icons-material';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { styled } from '@mui/system';
import { getOrCreateUserId } from './userUtils';
import { deleteProductFromList, voteProduct, unvoteProduct } from './listService';
import ZoomModal from './ZoomModal';

const VoteIconButton = styled(IconButton)({
    position: 'absolute',
    bottom: 16,
    right: 16,
    backgroundColor: 'white',
    color: '#E86161',
    '&:hover': {
        backgroundColor: 'white',
    }
})

const ProductCard = ({ productList, product }) => {
    const queryClient = useQueryClient();
    const [zoomOpen, setZoomOpen] = useState(false);
    const [imageIndex, setImageIndex] = useState(0);

    const deleteMutation = useMutation({
        mutationFn: () => deleteProductFromList(productList.id, product.id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['lists', productList.id] });
        }
    });

    const voteMutation = useMutation({
        mutationFn: () => voteProduct(productList.id, product.id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['lists', productList.id] });
        }
    });

    const unvoteMutation = useMutation({
        mutationFn: () => unvoteProduct(productList.id, product.id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['lists', productList.id] });
        }
    });

    const handleDelete = () => {
        deleteMutation.mutate();
    };

    const handleVote = () => {
        voteMutation.mutate();
    };

    const handleUnvote = () => {
        unvoteMutation.mutate();
    };

    const handleBuy = (product) => {
        window.location.href = "/?add-to-cart=" + product.id;
    };

    const handleZoomClose = () => {
        setZoomOpen(false);
    }

    const handleZoomOpen = () => {
        setZoomOpen(true);
    }

    const handleImageClick = (index) => {
        setImageIndex(index);
    };

    const isMine = productList.userId === getOrCreateUserId();

    return (
        <>
            <Card>
                <Box position="relative">
                    <CardMedia component="img" image = { product.imageUrls[imageIndex] } style={{ width: '100%', height:'100%' }} />
                    <IconButton
                    onClick={handleZoomOpen}
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        color: '#fff',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
                    }}
                    >
                        <ZoomInIcon />
                    </IconButton>

                    { !isMine && product.hasUserVoted && ( 
                        <VoteIconButton color="secondary" variant="outlined" onClick={handleUnvote} position="absolute" right={0} bottom={0}>
                            <Favorite/>
                        </VoteIconButton>
                    )}
                    { !isMine && !product.hasUserVoted && (
                        <VoteIconButton color="secondary" variant="outlined" onClick={handleVote} position="absolute" right={0} bottom={0}>
                            <FavoriteBorder/>
                        </VoteIconButton>
                    )}
                </Box>
                <CardContent>
                    <Box display="flex" justifyContent="center">
                        {
                        product.imageUrls.map((url, index) => (
                            <Box padding={2} key={index}>
                            <img src={url} alt={product.name} style={{ maxwidth: '100px', maxHeight: '100px' }} onClick={() => handleImageClick(index)} />
                            </Box>
                        ))
                        }
                    </Box>
                    { isMine  && (
                        <Box display="flex" gap={1}>
                            <Favorite sx={{ color: "#E86161"}}/>
                            <Typography variant="body1" sx={{ marginBottom: 1 }} display="flex">
                                {product.voteCount} like
                            </Typography>
                        </Box>
                    )}
                    <Typography variant="h5" sx={{ marginBottom: 1 }}>
                        {product.name}
                    </Typography>
                    <Typography variant="h6" sx={{ marginBottom: 1 }}>
                        {product.price} Ft
                    </Typography>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                    {
                        product.inStock ? (
                            <Button onClick={() => handleBuy(product)} fullWidth variant="contained" sx={{ marginRight: 1 }}>Megrendelem</Button>
                        ) : (
                            <Typography variant="body1" color="error">
                                Ezt a terméket megvásárolták
                            </Typography>
                        )
                    }
                    { isMine && (
                        <Button onClick={handleDelete} variant="contained" sx={{bgcolor: "#575757"}}><Delete /></Button>
                    )}
                    </Box>
                </CardContent>
            </Card>
            <ZoomModal zoomOpen={zoomOpen} onZoomClose={handleZoomClose} imageSrc={product.imageUrls[imageIndex]} altText={product.name}/>
        </>
    );
};

export default ProductCard;
